import {createAction} from 'redux-actions';
import {curry} from 'ramda';
import {DispatchAny} from '@pluto/@types';
import {setNotificationAction} from '@pluto/notification';
import {
    getQcJobState,
    getJobDeliveryStatus,
    deliveryJob,
} from '@pluto/rest';
import {QcJobStatusIndicatorStateItem} from '../JobStatusIndicator/JobStatusIndicatorTypes';
import {DeliveryJobsStatusPayload} from '../QCToolsTypes';

export const QC_JOB_STATE_SET = 'QC_JOB_STATE_SET';
export const GET_DELIVERY_JOBS_STATUS = 'GET_DELIVERY_JOBS_STATUS';
export const RESET_JOB_DELIVERY_STATUS = 'RESET_JOB_DELIVERY_STATUS';
export const RESET_QC_JOB_STATE = 'RESET_QC_JOB_STATE';
export const DELIVERY_JOB = 'DELIVERY_JOB';

export type QcJobStatusIndicatorPayload = QcJobStatusIndicatorStateItem[];

export const setQcJobStateAction = createAction<Promise<QcJobStatusIndicatorPayload>, number>(QC_JOB_STATE_SET, async (id: number) => {
    return await getQcJobState(id);
});

export const getDeliveryJobsStatusAction = createAction<Promise<DeliveryJobsStatusPayload>, number>(GET_DELIVERY_JOBS_STATUS, async (qcJobId: number) => {
    return await getJobDeliveryStatus(qcJobId);
});

export const deliveryJobAction = curry(async (qcJobId: number, dispatch: DispatchAny) => {
    try {
        const response = await deliveryJob(qcJobId);

        if (response.statusText === 'OK') {
            dispatch(getDeliveryJobsStatusAction(qcJobId));
        }
    } catch {
        dispatch(setNotificationAction({
            type: 'error',
            text: 'Error occured while delivering job',
        }));
    }
});

export const resetQcJobStateAction = createAction(RESET_QC_JOB_STATE);

export const resetJobDeliveryStatusAction = createAction(RESET_JOB_DELIVERY_STATUS);
